<script>
    import { isTranslationMissing } from "../util/findMissingTranslation";

    export let title;
    export let description = "";
    export let entity;
    export let schema;

    $: missingTranslation = isTranslationMissing(entity);

    import { createEventDispatcher } from "svelte";
    import AttentionMark from "./AttentionMark.svelte";

    $: codeLink =
        schema && schema.name == "audio_guide" && entity.code
            ? "https://" +
              window.location.hostname +
              "/admin/audio-guide/" +
              entity.id +
              "?code=" +
              entity.code
            : undefined;

    const dispatch = createEventDispatcher();
</script>

<div class="admin-card" style="padding: 40px 20px 20px 20px">
    <div class="text-box">
        <div class="headline-xs">{title}</div>
        <div class="text-s">{description}</div>
        {#if codeLink}
            <div style="font-size: 12px;">
                Zugangslink: <a href={codeLink}>{codeLink}</a>
            </div>
        {/if}
    </div>
    <div class="action-box">
        <div
            style="margin-left: 16px;cursor: pointer;"
            on:click={() => dispatch("click")}
            class="navigate-button"
        >
            <svg
                width="33"
                height="26"
                viewBox="0 0 33 26"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M0 13H32M32 13L17.0667 25M32 13L17.0667 1"
                    stroke="#1A1A17"
                />
            </svg>
        </div>
    </div>
</div>

<style>
    .admin-card {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        word-break: break-word;
        border: 1px solid var(--black-100);
    }

    .action-box {
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }
</style>
